export interface InboxDraftScope {
  tenantId: string;
  operatorEmail: string;
  sessionId: string;
}

export const INBOX_DRAFT_PREFIX = "cspro.inbox.draft.v1:";

function operatorScope(tenantId: string, operatorEmail: string): string {
  return [
    INBOX_DRAFT_PREFIX,
    encodeURIComponent(tenantId),
    ":",
    encodeURIComponent(operatorEmail.trim().toLowerCase()),
    ":",
  ].join("");
}

export function inboxDraftKey(scope: InboxDraftScope): string {
  return operatorScope(scope.tenantId, scope.operatorEmail)
    + encodeURIComponent(scope.sessionId);
}

export function readInboxDraft(storage: Storage, scope: InboxDraftScope): string {
  try {
    return storage.getItem(inboxDraftKey(scope)) ?? "";
  } catch {
    return "";
  }
}

export function writeInboxDraft(
  storage: Storage,
  scope: InboxDraftScope,
  draft: string,
): void {
  try {
    storage.setItem(inboxDraftKey(scope), draft);
  } catch {
    // Draft persistence is best-effort when browser storage is unavailable.
  }
}

export function clearInboxDraft(storage: Storage, scope: InboxDraftScope): void {
  try {
    storage.removeItem(inboxDraftKey(scope));
  } catch {
    // Clearing a draft must not interrupt the operator workflow.
  }
}

export function clearOperatorInboxDrafts(
  storage: Storage,
  tenantId: string,
  operatorEmail: string,
): void {
  const prefix = operatorScope(tenantId, operatorEmail);
  let length: number;
  try {
    length = storage.length;
  } catch {
    return;
  }

  const matchingKeys: string[] = [];
  for (let index = 0; index < length; index += 1) {
    try {
      const key = storage.key(index);
      if (key?.startsWith(prefix)) matchingKeys.push(key);
    } catch {
      // A failed key read must not prevent checking later snapshot indexes.
    }
  }

  for (const key of matchingKeys) {
    try {
      storage.removeItem(key);
    } catch {
      // Continue clearing the remaining operator-scoped drafts.
    }
  }
}
